import React from "react";
import PropTypes from "prop-types";
import Header from "./Header";
import Body from "./Body";
import Footer from "./Footer";
import { pymSendHeight } from "../utils/handlePym";

const SUBTITLE_TEXT =
  "Pennsylvania landlords have filed hundreds of eviction complaints since the state’s eviction ban expired at the end of August. Some tenants are now protected under a federal order in place since Sept. 4 and many cases remain tied up in the courts.";

const FOOTNOTE_TEXT =
  "The data represents evictions filed for any reason, not just unpaid rent. Not all eviction filings result in an actual eviction.";

class Main extends React.Component {
  componentDidMount() {
    // This is intended to fix bug where app is clipped at bottom
    // on initial load.
    pymSendHeight({ timeout: 500 });
    pymSendHeight({ timeout: 1000 });
  }

  componentDidUpdate() {
    // Because our app changes height based on displayed content, we
    // update the iframe height after DOM elements have been updated.
    pymSendHeight();
  }

  render() {
    const { data } = this.props;
    return (
      <div className="container__outer">
        <div className="container__inner">
          <Header
            headline="Hundreds of new eviction filings"
            subtitle={SUBTITLE_TEXT}
          />
          <Body data={data} />
          <Footer
            footnote={FOOTNOTE_TEXT}
            byline="Daniel Simmons Ritchie"
            source="CREATE Lab at Carnegie Mellon University and Philadelphia Legal Assistance"
            outlet="Spotlight PA"
            outletUrl="https://www.spotlightpa.org/"
          />
        </div>
      </div>
    );
  }
}

Main.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default Main;
